import React from "react";
import Header from "../../Sections/Header";
import Footer from "../../Sections/Footer";
import Price from "../../Sections/Price";
import NicheHero from "../../Components/NicheShared/NicheHero";
import NicheFeatures, { Feature } from "../../Components/NicheShared/NicheFeatures";
import NicheSteps from "../../Components/NicheShared/NicheSteps";
import NicheCTA from "../../Components/NicheShared/NicheCTA";
import NicheFollowUp from "../../Components/NicheShared/NicheFollowUp";
import RevealOnScroll from "../../Components/RevealOnScroll";
import { NavLink } from "../../types/nav";

const LINKS: NavLink[] = [
  { label: "Início",          to: "/saude#hero" },
  { label: "Funcionalidades", to: "/saude#features" },
  { label: "Como funciona",   to: "/saude#steps" },
  { label: "Planos",          to: "/saude#price" },
];

const FEATURES: Feature[] = [
  {
    icon: "mdi:calendar-clock-outline",
    title: "Agendamento automático",
    description: "Paciente escolhe data e horário direto pelo WhatsApp, sem precisar ligar.",
  },
  {
    icon: "mdi:bell-check-outline",
    title: "Confirmação e lembrete",
    description: "Reduz no-shows com mensagens automáticas antes da consulta.",
  },
  {
    icon: "mdi:account-arrow-right-outline",
    title: "Follow-up de retorno",
    description: "Alfred lembra o paciente na data certa para o próximo atendimento.",
  },
  {
    icon: "mdi:headset",
    title: "Transferência para humano",
    description: "Situações complexas? O Alfred passa a conversa para sua equipe.",
  },
];

const STEPS: string[] = [
  "Cadastre seus serviços e horários disponíveis",
  "Paciente agenda direto pelo WhatsApp",
  "Alfred confirma, lembra e faz follow-up automaticamente",
];

const Saude: React.FC = () => (
  <>
    <Header links={LINKS} />
    <NicheHero
      id="hero"
      headline={`Sua clínica atende no WhatsApp, <br/> mesmo quando você não está. <br/> O <span style="color:#E4DA1B;">Alfred</span> não descansa.`}
      subheadline="O Alfred agenda consultas, confirma retornos e faz follow-up de pacientes — sozinho."
    />
    <RevealOnScroll><NicheFeatures id="features" features={FEATURES} /></RevealOnScroll>
    <RevealOnScroll><NicheSteps id="steps" steps={STEPS} /></RevealOnScroll>
    <RevealOnScroll>
      <NicheFollowUp
        title="Recupere pacientes que sumiram. No automático."
        subtitle="O Alfred identifica pacientes inativos e dispara mensagens personalizadas no momento certo — sem spam, sem fluxo engessado."
        items={[
          "Lembre pacientes sobre retorno de consultas ou exames",
          "Reative contatos que não agendam faz tempo",
          "Envie avisos de campanhas e datas preventivas",
        ]}
      />
    </RevealOnScroll>
    <RevealOnScroll><NicheCTA phrase="Sua agenda mais cheia, seus pacientes mais bem atendidos." /></RevealOnScroll>
    <div id="price">
      <Price />
    </div>
    <Footer />
  </>
);

export default Saude;
